module.exports = __webpack_public_path__ + "static/media/undraw.7e3e23ce.png";